import React, {useEffect, useState} from "react";
import AuthService from "../../services/auth.service";
import {isLoggedInWithRole} from "../../common/utils";
import {Link, useParams} from "react-router-dom";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row} from "react-bootstrap";
import VenueItem from "../venues/venueItem.component";
import ActItem from "../acts/actItem.component";

const Profile = () => {

    let {userEmail} = useParams();

    const [currentUser, setCurrentUser] = useState()
    const [userResources, setUserResources] = useState()

    let loggedInHost = isLoggedInWithRole('host');
    let loggedInPerf = isLoggedInWithRole('performer');

    useEffect(() => {
        if (userEmail) {
            console.log("+++ userEmail=" + userEmail);
            AuthService.getUserResources(userEmail).then(
                response => {
                    setUserResources(response.data);
                    console.log("user resources:" + JSON.stringify(response.data));
                },
                error => {
                    console.log(error);
                });
        } else {
            setCurrentUser(AuthService.getCurrentUser());
        }
    }, [userEmail]);

    return (
        <>
            {currentUser &&
                <Container fluid>
                    <Row>
                        <Col>
                            <h3>
                                <Breadcrumb>
                                    <Breadcrumb.Item active>Profile</Breadcrumb.Item>
                                </Breadcrumb>
                            </h3>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <div>
                                <strong>Full name:</strong>&nbsp;{currentUser.name}<br/>
                                <strong>Email:</strong>&nbsp;{currentUser.email}<br/>
                                {/*<strong>Status:</strong>&nbsp;{currentUser.state}<br/>*/}

                                <strong>Roles:</strong><br/>
                                <ul>
                                    {currentUser.is_admin &&
                                        <li>Admin</li>
                                    }
                                    {currentUser.is_host &&
                                        <li>
                                            Host
                                        </li>
                                    }
                                    {currentUser.is_performer &&
                                        <li>
                                            Performer
                                        </li>
                                    }
                                </ul>
                            </div>
                            <hr/>

                            {loggedInHost &&
                                <div>
                                    To manage your venues, go to the <Link to="/myvenues" reloadDocument="true">My
                                    Venues</Link> page.
                                </div>
                            }
                            {loggedInPerf &&
                                <div>
                                    To manage your acts, go to the <Link to="/myacts" reloadDocument="true">My
                                    Acts</Link> page.
                                </div>
                            }
                        </Col>
                    </Row>
                </Container>
            }
            {userResources &&
                <Container fluid>
                    <Row>
                        <Col>
                            <h3>
                                <Breadcrumb>
                                    <Breadcrumb.Item active>Profile</Breadcrumb.Item>
                                </Breadcrumb>
                            </h3>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            This is the profile page for user: {userResources.name}
                        </Col>
                    </Row>
                    <br/>

                    {userResources.venues &&
                        <>
                            <Row>
                                <Col>
                                    The user is the creator of the following venues:
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    {userResources.venues.map((v, index) => (
                                        <VenueItem key={index} venue={v}/>
                                    ))}
                                </Col>
                            </Row>
                        </>
                    }

                    {userResources.acts &&
                        <>
                            <Row>
                                <Col>
                                    The user is the creator of the following acts:
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    {userResources.acts.map((a, index) => (
                                        <ActItem key={index} act={a}/>
                                    ))}
                                </Col>
                            </Row>
                        </>
                    }
                </Container>
            }

        </>
    );
};

export default Profile;

